import { QrCode, Image } from "lucide-react";
import { SAMPLE_DATA } from "./editorConstants";

const API = process.env.REACT_APP_BACKEND_URL;

export function CanvasElement({ el, isSelected, onMouseDown, onResizeMouseDown, preview, canvasW }) {
  const scaleFactor = canvasW / 595.27;
  const style = {
    position: "absolute",
    left: `${el.x}%`, top: `${el.y}%`,
    width: `${el.width}%`, height: `${el.height}%`,
    zIndex: el.zIndex || 0,
    opacity: el.opacity ?? 1,
    cursor: el.locked ? "default" : preview ? "default" : "move",
  };

  const renderContent = () => {
    if (el.type === "shape") {
      if (el.shape === "line") {
        return <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center" }}><div style={{ width: "100%", borderTop: `2px solid ${el.color || "#e2e8f0"}` }} /></div>;
      }
      return <div style={{ width: "100%", height: "100%", backgroundColor: el.color || "#e2e8f0", borderRadius: el.borderRadius || 0 }} />;
    }
    if (el.type === "image") {
      if (el.source === "logo") {
        return <div className="w-full h-full flex items-center justify-center bg-slate-50/60 text-slate-400 border border-dashed border-slate-300 rounded" style={{ fontSize: Math.max(7, 9 * scaleFactor) }}><Image className="w-3 h-3 mr-1 opacity-40" /> LOGO</div>;
      }
      if (el.source?.startsWith("/api/")) {
        return <img src={`${API}${el.source}`} alt="" className="w-full h-full object-contain" draggable={false} />;
      }
      return <div className="w-full h-full bg-slate-100 flex items-center justify-center text-[9px] text-slate-400">IMG</div>;
    }
    if (el.type === "qr") {
      return <div className="w-full h-full flex items-center justify-center bg-white border border-slate-200 rounded p-0.5"><QrCode className="w-3/4 h-3/4 text-slate-700" /></div>;
    }
    if (el.type === "text") {
      const fs = Math.max(5, (el.fontSize || 14) * scaleFactor * 0.75);
      return <div style={{ fontSize: fs, fontWeight: el.fontWeight || "normal", fontStyle: el.fontStyle || "normal", color: el.color || "#000", textAlign: el.textAlign || "left", backgroundColor: el.backgroundColor || "transparent", borderRadius: el.borderRadius || 0, borderColor: el.borderColor || "transparent", borderWidth: el.borderWidth || 0, borderStyle: "solid", padding: "1px 3px", overflow: "hidden", lineHeight: 1.2, width: "100%", height: "100%" }}>{el.text || ""}</div>;
    }
    if (el.type === "dynamic_field") {
      const fs = Math.max(5, (el.fontSize || 14) * scaleFactor * 0.75);
      const labelFs = Math.max(4, fs * 0.55);
      const value = SAMPLE_DATA[el.field] || `{${el.field}}`;
      return (
        <div style={{ padding: "1px 3px", width: "100%", height: "100%", textAlign: el.textAlign || "left" }}>
          {el.label && <div style={{ fontSize: labelFs, fontWeight: "bold", color: el.labelColor || "#94a3b8", letterSpacing: "0.4px", lineHeight: 1.2 }}>{el.label}</div>}
          <div style={{ fontSize: fs, fontWeight: el.fontWeight || "normal", fontStyle: el.fontStyle || "normal", color: el.color || "#000", lineHeight: 1.3, overflow: "hidden", whiteSpace: "nowrap" }}>{value}</div>
        </div>
      );
    }
    return null;
  };

  const handles = ["nw", "ne", "sw", "se"];
  return (
    <div style={style} onMouseDown={onMouseDown} data-testid={`canvas-el-${el.id}`}>
      {isSelected && <div className="absolute inset-0 bg-blue-500/5 border-2 border-blue-500 rounded-[1px] pointer-events-none" style={{ zIndex: 9999 }} />}
      {renderContent()}
      {isSelected && !el.locked && handles.map(h => (
        <div key={h} onMouseDown={e => onResizeMouseDown(e, h)}
          className="absolute w-2.5 h-2.5 bg-white border-2 border-blue-500 rounded-full shadow-sm"
          style={{ cursor: `${h}-resize`, zIndex: 10000, ...(h.includes("n") ? { top: -5 } : { bottom: -5 }), ...(h.includes("w") ? { left: -5 } : { right: -5 }) }}
          data-testid={`resize-${h}`} />
      ))}
      {isSelected && el.locked && (
        <div className="absolute -top-5 left-0 bg-amber-100 border border-amber-300 rounded px-1 py-0.5 text-[8px] text-amber-700 font-bold" style={{ zIndex: 10000 }}>BLOQUEADO</div>
      )}
    </div>
  );
}
